<template>
  <div class="dashboard">
    <div class="l-list" @click="$router.push({name: 'admin-lotto-results', params: { lottoType: 'gb' }})">
      <span class="flag-icon flag-icon-gb"></span>
      <div><strong>ENGLAND VIP</strong></div>
    </div>
    <div class="l-list" @click="$router.push({name: 'admin-lotto-results', params: { lottoType: 'de' }})">
      <span class="flag-icon flag-icon-de"></span>
      <div><strong>GERMANY VIP</strong></div>
    </div>
    <div class="l-list" @click="$router.push({name: 'admin-lotto-results', params: { lottoType: 'ru' }})">
      <span class="flag-icon flag-icon-ru"></span>
      <div><strong>RUSSIA VIP</strong></div>
    </div>
  </div>
</template>
<script>
export default {

}
</script>
<style lang="scss">
.dashboard {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;

  .l-list {
    width: 200px;
    margin: 15px;
    text-align: center;
    cursor: pointer;
    .flag-icon {
      font-size: 120px;
      border:1px solid #eee;
      margin-bottom: 10px;
    }
    strong {
      color: #00308E;
    }
  }
}
</style>
